export default __webpack_public_path__ + "static/media/February2020.3a22bc08.png";